import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CreateShowAssetsComponent from '../../../Components/ShowAssetsComponent/CreateShowAssetsComponent';

const CreateShowAssets = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    return (
        <div>
            <CreateShowAssetsComponent {...params} id={params.id} navigate={navigate} />
        </div>
    )
}

export default CreateShowAssets